export default __webpack_public_path__ + "static/media/Pamungkas.8d589a2a.png";